export default __webpack_public_path__ + "static/media/browser.f6398a38.png";